import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';


@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
  @Input() title;
  @Input() result;
  @Input() bill;

  constructor(private modal: ModalService) { }

  

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
  }

}
